export default "__VITE_ASSET__6f186589__"